module.exports = __webpack_public_path__ + "img/batam-lokal.817265e5.png";